export default "__VITE_ASSET__CWVYVXjL__"